import React from "react";
import InteractivesWidgetWrap from "./widgetBoxes/interactives/InteractivesWidgetWrap";

const InteractivesWidgets = ({
  dataType,
  data,
  loadCSS,
  dataClient = false,
  websiteBaseUrl,
  dataPath,
  dictionary,
  containerEl,
}) => {
  if (dataType?.startsWith("interactives-")) {
    return (
      <InteractivesWidgetWrap
        dataType={dataType}
        data={data}
        loadCSS={loadCSS}
        dataClient={dataClient}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
        dictionary={dictionary || {}}
        containerEl={containerEl}
      />
    );
  }

  return null;
};

export default InteractivesWidgets;
